"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var SimpleCard_1 = __importDefault(require("../DeveloperSectionContainer/SimpleCard"));
var BuildingCard_1 = __importDefault(require("../DeveloperSectionContainer/BuildingCard"));
var ApartmentCard_1 = __importDefault(require("./ApartmentCard"));
var PostTabsContext_1 = require("../../../../../contexts/PostTabsContext");
var PersonalSectionContainer = function (_a) {
    var steps = _a.steps, formikProps = _a.formikProps, post = _a.post, isLoaded = _a.isLoaded, removeParentEntityMedia = _a.removeParentEntityMedia, reorderMedia = _a.reorderMedia;
    var handleChangeSchema = react_1.useContext(PostTabsContext_1.PostTabsContext).handleChangeSchema;
    react_1.useEffect(function () {
        handleChangeSchema({
            deal: formikProps.values.deal,
            propertyType: formikProps.values.initial_info.property_type,
        });
    }, [
        formikProps.values.deal,
        formikProps.values.initial_info.property_type,
    ]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(SimpleCard_1.default, { step: steps[0], formikProps: formikProps, post: post, isLoaded: isLoaded, reorderMedia: reorderMedia }),
        react_1.default.createElement(SimpleCard_1.default, { step: steps[1], formikProps: formikProps, post: post, isLoaded: isLoaded, reorderMedia: reorderMedia }),
        react_1.default.createElement(BuildingCard_1.default, { step: steps[2], formikProps: formikProps, post: post, isLoaded: isLoaded, removeParentEntityMedia: removeParentEntityMedia, reorderMedia: reorderMedia }),
        react_1.default.createElement(ApartmentCard_1.default, { step: steps[3], formikProps: formikProps, post: post, isLoaded: isLoaded }),
        react_1.default.createElement(SimpleCard_1.default, { step: steps[4], formikProps: formikProps, post: post, isLoaded: isLoaded, reorderMedia: reorderMedia })));
};
exports.default = PersonalSectionContainer;
